/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import moment from "moment";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import ArmModal from "../ARM/ArmModal.vue";

export default {
  name: "StudyArm",
  components: {
    VPagination,
    ArmModal
  },
  data() {
    return {
      searchField: {
        country: "",
        status: "",
      },
      baseurl: process.env.VUE_APP_Service_URL,
      currentPage: 1,
      totalPage: 1,
      pageindex: 1,
      pagesize: 15,
      SortProperty: "createdAt",
      SortOrder: 1,
      SortOrderInt: 0,
      isAscending: true,
      armList: [],
      totalCount: 0,
      showTableLoading: false,
      idToken: "",
      showFilter: false,
      selectedcolumnobj: {},
      roleprivileges: "",
      CountryStatus: [],
      dropdownOpen: false,
      showCreatearmModal: false,
      editingArmId: null,
    }
  },
  watch: {
    returnList: {
      handler() {
        this.initializeColumns();
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    window.addEventListener("studyIdChanged", (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.idToken = store.getters.getIdToken;
      this.listArms();
    });
    await this.listArms();
  },

  methods: {
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    initializeColumns() {
      if (this.armList.length > 0) {
        const allowedKeys = [
          "Country Name",
          "Country Code",
          "Notes",
          "Active",
          "Language",
          "Language Code",
        ];

        const fieldLabels = {
          countryName: "Country Name",
          countryCode: "Country Code",
          notes: "Notes",
          active: "Active",
          language: "Language",
          languageCode: "Language Code",
        };

        const readableData = allowedKeys.map((key) => fieldLabels[key] || key);
        this.getColumns = readableData;

        this.selectedColumns = [...this.getColumns];

        this.selectedcolumnobj = this.selectedColumns.reduce((obj, key) => {
          obj[key] = true;
          return obj;
        }, {});
      }
    },

async listArms() {
  try {
    this.showTableLoading = true;
    const currentstudy = store.getters.getStudyIs;
    this.idToken = store.getters.getIdToken;

    const response = await axios.get(`${this.baseurl}/fhir-service/arm/getarmsbystudyid?study_id=${currentstudy}`, {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json"
      }
    });


    this.armList = response.data || [];
    
    this.totalCount = this.armList.length;
    this.totalPage = Math.ceil(this.totalCount / this.pagesize);
  } catch (error) {
    console.error("Error fetching arms:", error);
    this.armList = [];
  } finally {
    this.showTableLoading = false;
  }
},


EditArm(Id) {
  this.editingArmId = Id;
  console.log("Editing ARM with ID:", Id);
  this.showCreatearmModal = true;
},
async DeleteArm(Id) {
  if (confirm("Are you sure you want to delete this ARM?")) {
    try {
      const response = await axios.delete(`${this.baseurl}/fhir-service/arm/deletebyid?arm_id=${Id}`, {
        headers: {
          Authorization: "Bearer " + this.idToken,
          "Content-Type": "application/json"
        }
      });
      alert("ARM deleted successfully.");
      this.listArms();
    } catch (error) {
      console.error("Error deleting ARM:", error);
      alert("Failed to delete ARM.");
    }
  }
},

    loadPage(page) {
      this.currentPage = page;
      this.listArms();
    },

    async search() {
      this.pageindex = 1;
      this.currentPage = 1;
      this.listArms();
    },

    formatDateDDMMYYYY(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getUTCDate()).padStart(2, "0");
      const month = String(d.getUTCMonth() + 1).padStart(2, "0");
      const year = d.getUTCFullYear();
      return `${day}-${month}-${year}`;
    },

    SortSelected(sortProp) {
      if (this.SortProperty === sortProp) {
        this.isAscending = !this.isAscending;
      } else {
        this.SortProperty = sortProp;
        this.isAscending = true;
      }
      this.SortOrderInt = this.isAscending ? 0 : 1;
      this.pageindex = 1;
      this.currentPage = 1;
      this.listArms();
    },


    closeArmModal() {
      this.showCreatearmModal = false;
      this.editingArmId = null;
    },
 CreateARM() {
  this.editingArmId = null;
  this.showCreatearmModal = true;
},


    async refreshArmList() {
      await this.listArms();   
    }
  }
};